import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyDeliveryIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./DeliveryIcon-0ffbcd88.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyDeliveryIcon as P };
